/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.27/esri/copyright.txt for details.
*/
import{VisualVariablesParameters as r}from"../../layers/support/FastSymbolUpdates.js";import{RenderOccludedFlag as s}from"../lib/Material.js";class t extends r{constructor(){super(...arguments),this.renderOccluded=s.Occlude}}const e=8;export{t as VisualVariablePassParameters,e as vvColorNumber};
